import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['decompositionSubForm', 'checkbox', 'totalValueInput', 'componentValueInput']

  toggleDecomposition() {
    this.toggleDecompositionSubFormVisibility()
    this.setTotalValueInputReadOnly()
  }

  toggleDecompositionSubFormVisibility() {
    if (this.checkboxTarget.checked) {
      this.decompositionSubFormTarget.classList.remove('d-none')
    } else {
      this.decompositionSubFormTarget.classList.add('d-none')
    }
  }

  setTotalValueInputReadOnly() {
    this.totalValueInputTarget.readOnly = this.checkboxTarget.checked
  }

  updateTotalValue() {
    const total = this.componentValueInputTargets
      .filter(input => input.value)
      .reduce((sum, input) => sum + Number.parseFloat(input.value), 0)

    this.totalValueInputTarget.value = Number.parseFloat(total.toPrecision(12))
  }
}
